import {
  localStorageKey as LocalStorageKeyEnum,
  validatePurchasePolicyLocalStorage,
  validateSystemSettingsLocalStorage,
  validateVerifyPolicyLocalStorage,
} from './validateLocalStorage';
import {
  PurchasePolicyLocalStorage,
  SystemSettingsLocalStorage,
  VerifyPolicyLocalStorage,
} from './validateLocalStorage/validateLocalStorage.types';

type Key = 'input' | 'additionalData' | 'flow' | 'complianceProvider';
interface Options {
  saveToLocalStorage: boolean;
  key: Key;
  localStorageKey: LocalStorageKeyEnum;
  input: object;
}

const assignLocalStorage = (localStorageKey: string) => {
  if (localStorageKey.includes(LocalStorageKeyEnum.purchasePolicy)) {
    return validatePurchasePolicyLocalStorage();
  }

  if (localStorageKey.includes(LocalStorageKeyEnum.verifyPolicy)) {
    return validateVerifyPolicyLocalStorage();
  }

  if (localStorageKey.includes(LocalStorageKeyEnum.systemSettings)) {
    return validateSystemSettingsLocalStorage();
  }

  throw new Error('Invalid localStorage key');
};

export const saveToLocalStorageHelper = ({
  saveToLocalStorage,
  key,
  localStorageKey,
  input,
}: Options) => {
  try {
    const isFlatStorage = [
      LocalStorageKeyEnum.systemSettings,
      LocalStorageKeyEnum.shared,
    ].includes(localStorageKey);

    const storage:
      | PurchasePolicyLocalStorage
      | VerifyPolicyLocalStorage
      | SystemSettingsLocalStorage = assignLocalStorage(localStorageKey);

    if (saveToLocalStorage) {
      let dataToSave = isFlatStorage
        ? storage
        : (storage as PurchasePolicyLocalStorage | VerifyPolicyLocalStorage)[
            key
          ];
      if (dataToSave) {
        dataToSave = { ...dataToSave, ...input };
      } else {
        dataToSave = input;
      }
      localStorage.setItem(localStorageKey, JSON.stringify(dataToSave));
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
};
